/*
 * Copyright 2019 Bitban Technologies, S.L.
 * Todos los derechos reservados.
 */

export default () => {
    $('.rrss:not(.no-share) a').off('click').click(function () {

        if ($(this).hasClass('rrss-link twitter')) {
            window.open($(this).attr('data-href'), '_blank');
        }

        if ($(this).hasClass('rrss-link facebook')) {
            window.open($(this).attr('data-href'), '_blank');
        }

        if ($(this).hasClass('rrss-link pinterest')) {
            window.open($(this).attr('data-href'), '_blank');
        }
    });
}
